var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',[_c('Loader',{attrs:{"loading":_vm.loading}})],1):_c('div',[(_vm.isAdvanced)?_c('AdvancedProduct'):_c('MiniProduct')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }